import React from 'react';
import "./ServiceContentStyles.css";

function ServiceContent() {
  return (
  <>
  
  <div className="services-container">
  <div className="service-card">
    <h3>Trip Management</h3>
    <p>Plan and organize your trips efficiently with our trip management tools.Whether you're exploring a new city or embarking on a cross-country adventure, our platform helps you manage your itinerary.</p>
  </div>
  <div className="service-card">
    <h3>Share Itinerary</h3>
    <p>Easily share your travel itinerary with friends and family.With Tripper, you can create detailed travel plans, set budgets, and effortlessly organize every aspect of your journey. Say goodbye to the hassle of scattered notes and multiple apps.</p>
  </div>
  <div className="service-card">
    <h3>Share Your Experiences</h3>
    <p>Read and share authentic travel experiences from real travelers. From hidden gems to local customs, our community of travelers offers firsthand insights and stories that bring your destinations to life. .</p>
  </div>
  <div className="service-card">
    <h3>Track Expenses</h3>
    <p>Keep track of expenses, and ensure you never miss a moment of excitement. With Tripper, you can create detailed travel plans, set budgets, and effortlessly organize every aspect of your journey.</p>
  </div>
 
</div>

  
  </>
  )
}

export default ServiceContent
